module.exports = __webpack_public_path__ + "static/mockup-84f12f8724c7e95cfeebaf7ec758453f.webp";